import * as React from 'react';
import { cva, type VariantProps } from 'class-variance-authority';
import { cn } from '@/lib/utils';

const badgeVariants = cva(
  'inline-flex items-center gap-1 rounded-[4px] border px-1.5 py-px text-[10px] font-medium leading-[16px] whitespace-nowrap [&_svg]:size-3',
  {
    variants: {
      variant: {
        default: 'border-transparent bg-primary/10 text-primary',
        outline: 'border-border bg-card text-muted-foreground',
        muted: 'border-transparent bg-muted text-muted-foreground',
        evidence: 'border-transparent bg-[var(--color-evidence)]/10 text-[var(--color-evidence)]',
        lead: 'border-transparent bg-[var(--color-lead)]/10 text-[var(--color-lead)]',
        assess: 'border-transparent bg-[var(--color-assess)]/12 text-[var(--color-assess)]',
        cord: 'border-transparent bg-[var(--color-cord)]/10 text-[var(--color-cord)]',
        solid: 'border-transparent bg-foreground text-card',
      },
    },
    defaultVariants: { variant: 'outline' },
  }
);

export interface BadgeProps
  extends React.HTMLAttributes<HTMLSpanElement>,
    VariantProps<typeof badgeVariants> {}

export function Badge({ className, variant, ...props }: BadgeProps) {
  return <span className={cn(badgeVariants({ variant }), className)} {...props} />;
}

export { badgeVariants };